export enum FormularioEstado {
  pendiente = "PENDIENTE",
  incorporado = "INCORPORADO",
  noApto = "NO_APTO",
  rechazado = "RECHAZADO",
  realizadorPorError = "REALIZADO_POR_ERRROR",
  realizadoPorError = "REALIZADO_POR_ERROR",
  listaDeEspera = "LISTA_DE_ESPERA",
  admitidoNoUsaServicio = "ADMITIDO_NO_USA_SERVICIO",
}
